import { render, staticRenderFns } from "./ImageRenderComparisonComp.vue?vue&type=template&id=2ba2cc58&"
import script from "./ImageRenderComparisonComp.vue?vue&type=script&lang=js&"
export * from "./ImageRenderComparisonComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports